const Divider: React.FC = () => {
  return (
    <div className="flex p-4 mt-2">
      <div className="flex content-center h-px w-full bg-gray-200" />
    </div>
  );
};
export default Divider;
